import { render, staticRenderFns } from "./Question_SUS.vue?vue&type=template&id=12c8a05b&scoped=true&"
import script from "./Question_SUS.vue?vue&type=script&lang=js&"
export * from "./Question_SUS.vue?vue&type=script&lang=js&"
import style0 from "./Question_SUS.vue?vue&type=style&index=0&id=12c8a05b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c8a05b",
  null
  
)

export default component.exports